export default [
    {
        path: 'agendar',
        component: () => import(
            '@/views/transporte-paciente/agendar/Index'
        ),
        redirect: 'agendar/list',
        children: [
            {
                name: 'transporte-paciente-agendar-list',
                path: 'list',
                component: () => import(
                    '@/views/transporte-paciente/agendar/List'
                ),
            },
            {
                name: 'transporte-paciente-agendar-create',
                path: 'create/:id',
                props: route => ({ id: parseInt(route.params.id) }),
                component: () => import(
                    '@/views/transporte-paciente/agendar/Form'
                ),
            },
            {
                name: 'transporte-paciente-agendar-edit',
                path: 'edit/:id',
                props: route => ({ id: parseInt(route.params.id) }),
                component: () => import(
                    '@/views/transporte-paciente/agendar/Form'
                ),
            },
        ],
    },
]